import { useCallback, useMemo } from "react";

import { useContactWidgetDataContext } from "app/pages/sales-intelligence/modules/ai-agent/context/ContactWidgetDataContext";
import { aiAgentQueryKeys } from "app/pages/sales-intelligence/modules/ai-agent/queries/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type {
    ContactsDataSource,
    ContactsFlowStrategy,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/context/ContactsFlowContext.types";

const superAgentDataSource: ContactsDataSource = {
    revealSingle: salesApiService.contacts.revealSingleContact,
    revealMultiple: salesApiService.contacts.revealContactsById,
    exportExcel: salesApiService.contacts.exportToExcel,
};

export const useSuperAgentContactsFlowStrategy = (): ContactsFlowStrategy => {
    const contactWidgetDataContext = useContactWidgetDataContext();
    const contactWidgetData = contactWidgetDataContext?.contactWidgetData;

    const getRevealCacheKey = useCallback(
        () => aiAgentQueryKeys.superAgent.contacts(contactWidgetData ?? []),
        [contactWidgetData],
    );

    return useMemo<ContactsFlowStrategy>(
        () => ({
            dataSource: superAgentDataSource,
            getRevealCacheKey,
        }),
        [getRevealCacheKey],
    );
};
